import { render } from "./ClearVideo.vue?vue&type=template&id=be7713aa&scoped=true"
import script from "./ClearVideo.vue?vue&type=script&lang=js"
export * from "./ClearVideo.vue?vue&type=script&lang=js"

import "./ClearVideo.vue?vue&type=style&index=0&id=be7713aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7713aa"]])

export default __exports__